import React, { Component } from 'react';

/**
 * cid=1_1_1&page=3
 * cid=2_1_1&page=8 一页存在多次圈图动画
 */

// let rangeSize = 50; //感应范围容错大小，越大越容易拖进框内

class AutoCircle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            drawNum: 0,
            startX: 0,
            startY: 0,
        }
    }

    componentDidMount() {
        const that = this;
        const { item } = this.props;
        if (item && item.detail && item.detail.linepoints) {
            that.drawLine();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const { drawNum } = this.state;
        if (drawNum > 0 && drawNum !== prevState.drawNum) {
            that.drawLine();
        }
    }

    drawLine() {
        const that = this;
        const { item } = this.props;
        const { drawNum, startX, startY } = this.state;
        if (item && item.detail && item.detail.linepoints) {
            const c = document.getElementById('circleCanvas');
            const ctx = c.getContext("2d");
            const linepoints = item.detail.linepoints;

            if (drawNum < linepoints.length - 1) {
                setTimeout(() => {
                    that.setState({
                        drawNum: drawNum + 1,
                        startX: linepoints[drawNum].x,
                        startY: linepoints[drawNum].y,
                    }, () => {
                        if (drawNum > 0) {
                            ctx.beginPath();
                            ctx.moveTo(startX * 690, startY * 518);//起始位置
                            ctx.lineTo(linepoints[drawNum].x * 690, linepoints[drawNum].y * 518);//停止位置
                            ctx.lineWidth = 5;
                            ctx.strokeStyle = "#4ec6f5";
                            ctx.stroke();
                        }
                    });
                }, 400 / linepoints.length);
            }

        }
    }

    render() {
        return (
            <canvas id="circleCanvas" width="690" height="518" style={{
                "position": "absolute",
                "top": 0,
                "left": 0,
            }} />
        );
    }
}

export default AutoCircle;



// WEBPACK FOOTER //
// ./src/components/review/AutoCircle.js